import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnChanges, ViewEncapsulation, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { Campaign3Service } from '../../services/campaign3.service';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Campaign3ActionStatus, Campaign3Info, Campaign3MessageInstanceRules, Campaign3StatusMapping, DistributionListCluster, DistributionListDetails, JsonSchema, JsonSchemaFormPropertiesForm, MessageInstanceObject, MessageInstanceObjectTypes, MessageInstanceRule, MessageInstanceRuleDetail, MessageInstanceRuleTypes, Touchpoint } from '../../models/campaign-3.model';
import { MessageService } from 'primeng/primeng';
import { ClusterHeadNewList } from '../../models/campaign-3-customer-target.model';
import { Router } from '@angular/router';
import { CertificationTouchpointList } from '../../models/campaign-3-validation.model';
import { Campaign3Wizard } from '../../models/campaign-3-touchpoint.model';
import { Observable } from 'rxjs';
import { FormFields } from '../../components/form-fields/form-fields.component';
import { deflate } from 'zlib';
import { TouchPointUserComponent } from 'app/views/promotion/touch-point-user/touch-point-user.component';
import { TranslateService } from '@ngx-translate/core';
import { KPromoService } from 'app/services/kloy/kpromo.service';
import { DeployType } from 'app/models/kloy.model';
import { AuthService } from 'app/services/user/auth.service';


@Component({
  selector: 'app-campaign-3-validations',
  templateUrl: './campaign-3-validations.component.html',
  styleUrls: ['./campaign-3-validations.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3ValidationsComponent implements OnInit, OnDestroy {

  disable = {
    generaCouponPreview: true,
    generaDefinitiviRichiediPubblicazioni: false,
    annullaPubblicazione: false,
    aggiornaAzione: false,
    pubblicaNuovamente: false
  }

  @Input() actionTypeCode: string = "";
  @Input() statusMapping: Campaign3StatusMapping;
  @Input() campaignInfo: Campaign3Info = null;
  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() formSchema: any;
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() readOnly: boolean = false;
  @Input() statusList: Array<Campaign3ActionStatus> = [];
  @Input() deployTypeCoupon: string = "";

  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();
  @Output() formSchemaChanged: EventEmitter<JsonSchema> = new EventEmitter<JsonSchema>();

  @ViewChildren('wizard_emission') wizardEmissionComponent: QueryList<FormFields>;
  @ViewChildren('wizard_fruition') wizardFruitionComponent: QueryList<FormFields>;
  isWizardEmissionDisabled: boolean = false;
  isWizardFruitionDisabled: boolean = false;

  certificationTouchpointList: CertificationTouchpointList = new CertificationTouchpointList();

  certificationInfo = {
    needsCertification: false, //utilizzato per sapere se c'è almeno un touchpoint certificatore
    isCertificated: false, //utilizzato quando esiste almeno un touchpoint certificatore, indica se tutti i touchpoint certificatori hanno certificato
    loaded: false
  }

  valid: boolean = true;

  show = {
    form: false,
    generaCouponPreview: false,
    generaDefinitiviRichiediPubblicazioni: false,
    annullaPubblicazione: false,
    aggiornaAzione: false,
    modalCoupon: false,
    modalWizard: false,
    pubblicaNuovamente: false
  }

  @Input() distributionListEmission: Array<DistributionListCluster> = [];
  @Input() distributionListFruition: Array<DistributionListCluster> = [];
  @Input() accumulatorListEmission: Array<any> = [];
  @Input() accumulatorListFruition: Array<any> = [];
  @Input() touchpointListEmission: Array<Touchpoint> = [];
  @Input() touchpointListFruition: Array<Touchpoint> = [];
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";

  @Output() editClicked: EventEmitter<number> = new EventEmitter<number>();


  private interval: any;


  /*********************EMISSION*************************/

  //CV
  emissionTreshold;//PTRE
  emissionTrasholdType;//PTRT
  emissionMaxCouponNumber;//PMCN
  ripetibleEmissionTreshold;//PRTR

  //LM TransactionFruitionLimit
  emissionTACM //TACM
  emissionPMCT  //PMCT

  //AC
  emissionAccumulator;//TACM
  emissionAccumulationRule;//JAAR
  emissionControlRule;//JACR

  //cambiamenti
  emissionAccumulatorToMove;
  emissionAccumulatorToControl;

  //CT
  distributionEmissionList; //TDIS;

  //OL
  touchPointEmission: Array<any> = [] //TOCH



  //PT
  basket = {
    exclude: 0,
    include: 0
  };
  productDepartment = {
    exclude: 0,
    include: 0
  };
  productCategory = {
    exclude: 0,
    include: 0
  };
  productItem = {
    exclude: 0,
    include: 0
  };
  //WZ
  wizardEmission;

  /*********************FRUITION*************************/

  //CV fruition
  fruitionTreshold//PTRE
  fruitionTrasholdType;//PTRT
  fruitionMaxCouponNumber;//PMCN
  ripetibleFruitionTreshold;//PRTR

  //LM fruition
  fruitionPMCT: string;
  fruitionTACM: any;

  //CT fruition
  distributionFruitionList;

  //AC fruition
  fruitionAccumulator;//TACM;
  fruitionAccumulationRule;//JAAR
  fruitionControlRule;//JACR
  //nuovicampi
  fruitionAccumulatorToMove;
  fruitionAccumulatorToControl;

  //OL
  touchPointFruition: Array<any> = [] //TOCH

  //PT
  basketFruition = {
    exclude: 0,
    include: 0
  };
  productDepartmentFruition = {
    exclude: 0,
    include: 0
  };
  productCategoryFruition = {
    exclude: 0,
    include: 0
  };
  productItemFruition = {
    exclude: 0,
    include: 0
  };
  //WZ
  wizardFruition

  /*********************COMMON*************************/

  //BA
  productItemBarcodeAttivazione;//TBCD
  eanBarcodeAttivazione;//PBCD

  //BC
  productItemBarcodeCupon;//TBCD
  eanBarcodeCoupon;//PBCD

  /******************FRONTEND-DATA***********************/

  //date
  startFruitionDate;
  endFruitionDate;

  //date
  startEmissionDate;
  endEmissionDate;

  //bodyInfo
  actionType;
  name;
  discountType;
  generationMethod;
  targetLoyaltyClass;
  description;
  actualGeneratedCoupon;
  id;


  //appositi per semplificare html del popup
  barcodeCoupon;
  barcodeAttivazione;
  accumulatoriEmissione;
  accumulatoriFruizione;
  listaDistribuzioneEmissione;
  listaDistribuzioneFruizione;
  targetArticoliEmissione;
  targetArticoliFruizione;
  touchPointEmissione;
  touchPointFruizione;
  numeroNegoziEmissione;
  numeroNegoziFruizione;
  sogliaDiEmissione: { type: string, value: number };
  sogliaDiFruizione: { type: string, value: number };
  emissioneRipetibile: { type: string, value: number, max: number };
  fruizioneRipetibile: { type: string, value: number, max: number };

  summaryAccumulatorToMove: any[] = [];
  summaryAccumulatorToControl: any[] = [];

  summaryAccumulatorToMoveFruition: any[] = [];
  summaryAccumulatorToControlFruition: any[] = [];

  variableDates: boolean = false;

  publicationRejected: boolean = false;
  publicationRejectedMsgError: string = '';




  disablingSavingWizardState: boolean = false;
  /* Temp variaable da spostare su */
  couponingMethodMap = {
    'D': 'Dinamico',
    'S': 'Statico'
  };
  customerTarget = {
    'LOY': 'Loyalty',
    'ALL': 'Tutti',
    'NoLoy': 'No Loyalty'
  };

  statusDescription: string = "";

  deployTypeList: Array<DeployType> = [];
  deployTypesLoaded = false;

  constructor(
    public srvCampaign3: Campaign3Service,
    private translate: TranslateService,
    private srvCalTranslate: CalendarTranslateService,
    private srvNotify: MessageService,
    public router: Router,
    private srvKPromo: KPromoService,
    private srvAuth: AuthService

  ) {

  }

  //New Part--------------------------------------------------------

  touchpoints = {
    E: {
      OFF: [],
      ON: []
    },
    F: {
      OFF: [],
      ON: []
    }
  }
  ///newthings
  wizardList: Array<Campaign3Wizard> = [];
  currentInfo = {
    type: null,
    touchpointSelected: null,
    offline_online: null
  }



  //li ho preparati ma non riesco a popolarli
  //campbiare la logica di popolamento
  /* certifierTouchPointEmission : Array<any> = [] //TOCH
  certifierTouchPointFruition : Array<any> = [] //TOCH */

  @Output() saveWizard: EventEmitter<any> = new EventEmitter();

  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes> = [];
  rules_OL_emission: Array<MessageInstanceRule> = [];
  rules_WZ_emission: Array<MessageInstanceRule> = [];

  rules_OL_fruition: Array<MessageInstanceRule> = [];
  rules_WZ_fruition: Array<MessageInstanceRule> = [];


  /* @Input() touchpointListEmissionForWizard: Array<any> = [];
  @Input() touchpointListFruitionForWizard: Array<any> = []; */
  @Output() resetState: EventEmitter<any> = new EventEmitter();

  campaign3MessageInstanceRules: Campaign3MessageInstanceRules;
  displayDeleteDialog: boolean = false;

  createRules_Wizard() {
    let retValue = true;
    this.rules_WZ_emission = [];
    this.rules_WZ_fruition = [];

    // Regola Wizard per l'emissione
    let ruleWZ_emission = new MessageInstanceRule();
    ruleWZ_emission.messageInstanceId = this.messageInstanceObject.id;
    ruleWZ_emission.ruleTypeId = this.miRuleTypesList.find(x => x.code == "WZ").id;
    ruleWZ_emission.ruleType = "WZ";
    ruleWZ_emission.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
    ruleWZ_emission.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.EMISSION;

    // Touchpoint certifier emissione
    for (let tp of this.touchPointEmission) {
      if (tp.active == true && tp.wizardModel && tp.wizardModel.id > 0) {
        let mird = new MessageInstanceRuleDetail();
        mird.objectTypeCode = "TWIZ";
        mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TWIZ").id;
        mird.objectId = tp.wizardModel.id;
        mird.objectValue = tp.ochannel_id;
        ruleWZ_emission.messageInstanceRuleDetail.push(mird);
      }
    }

    if (ruleWZ_emission.messageInstanceRuleDetail.length > 0) {
      this.rules_WZ_emission.push(ruleWZ_emission);
    }

    // Regola Wizard per la fruizione
    let ruleWZ_fruition = new MessageInstanceRule();
    ruleWZ_fruition.messageInstanceId = this.messageInstanceObject.id;
    ruleWZ_fruition.ruleTypeId = this.miRuleTypesList.find(x => x.code == "WZ").id;
    ruleWZ_fruition.ruleType = "WZ";
    ruleWZ_fruition.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
    ruleWZ_fruition.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.FRUITION;

    // Touchpoint certifier fruizione
    for (let tp of this.touchPointFruition) {
      if (tp.active == true && tp.wizardModel && tp.wizardModel.id > 0) {
        let mird = new MessageInstanceRuleDetail();
        mird.objectTypeCode = "TWIZ";
        mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TWIZ").id;
        mird.objectId = tp.wizardModel.id;
        mird.objectValue = tp.ochannel_id;
        ruleWZ_fruition.messageInstanceRuleDetail.push(mird);
      }
    }

    if (ruleWZ_fruition.messageInstanceRuleDetail.length > 0) {
      this.rules_WZ_fruition.push(ruleWZ_fruition);
    }
    // Controllo finale per segnalare errore se entrambe le liste sono vuote
    if (this.rules_WZ_emission.length === 0 && this.rules_WZ_fruition.length === 0) {
      // Segnala errore (puoi gestire l'errore come preferisci)
      console.error("Errore: Entrambe le liste delle regole sono vuote.");
      // Puoi anche lanciare un'eccezione se necessario
      retValue = false;
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('NoWizard selected')
      });
    }
    return retValue;
  }


  //Chiamare se necessario
  @Output() touchpointRef: EventEmitter<any> = new EventEmitter();
  refreshTouchPoint() {

    this.touchpointRef.emit();
  }








  ngOnInit() {

    /*
      NOTA IMPORTANTE: quando sono quì a Validazioni, devo iniziare a considerare il campo "status" della
      message instance, come lo stato attuale. Da quì tutte le operazioni che verranno fatte sullo stato,
      verranno considerate come stato attuale e non "il prossimo stato incompleto" come avveniva per i vari tab
    */

    /***
     *
     * LISTA STATI per validazione:
     *
     * 0 --> completa pronta per la preview
     * G --> Generata in preview
     * R --> In generazione preview
     * E --> Errore generazione preview
     * P --> Pubblicata
     * S --> Pubblicazione in invio
     * Q --> Richiesta pubblicazione
     * X --> Pubblicazione rifiutata
     *
     *  ***/



    this.show.form = true;
    console.log("messageInstanceObject", this.messageInstanceObject);

    this.reloadData();


  }



  setStatusDescription() {

    let currentStatus = this.statusList.find(x => x.code == this.messageInstanceObject.status);
    if (currentStatus) {
      this.statusDescription = currentStatus.description;
    }
    //correzione nel caso ci siano state delle modifiche lo stato è da ripubblicare
    if (this.messageInstanceObject.status == 'P' && this.messageInstanceObject.flgDpl == '1') {
      this.statusDescription = (this.language == "it" ? "Da Ripubblicare" : "To Republish");
    }


  }
  getCertifierValue(yesOrNo: boolean): string {
    if (yesOrNo == true) {
      return this.srvCampaign3.touchpointCertifier.YES;
    }
    else {
      return this.srvCampaign3.touchpointCertifier.NO;
    }
  }
  getCertifiedValue(yesOrNo: boolean): string {
    if (yesOrNo == true) {
      return this.srvCampaign3.touchpointCertified.YES;
    }
    else {
      return this.srvCampaign3.touchpointCertified.NO;
    }
  }
  /* Dai un occhiata che è qusta la funzione che dice se la promo è certificata*/

  checkCertificationInfo() {


    var self = this;

    this.srvCampaign3.getAllCertificationTouchpoint(this.messageInstanceObject.id).subscribe(res => {

      if (res) {
        self.certificationTouchpointList = Object.assign({}, res);


        for (let tp of self.touchPointEmission) {
          if (tp.certifier == self.srvCampaign3.touchpointCertifier.YES) {
            self.certificationInfo.needsCertification = true;
            break;
          }
        }

        for (let tp of self.touchPointFruition) {
          if (tp.certifier == self.srvCampaign3.touchpointCertifier.YES) {
            self.certificationInfo.needsCertification = true;
            break;
          }
        }


        self.certificationInfo.isCertificated = (self.certificationTouchpointList.notCertifiedTouchpoint && self.certificationTouchpointList.notCertifiedTouchpoint.length > 0) ? false : true;

        if (self.messageInstanceObject.status == "G" && self.certificationInfo.isCertificated) {
          self.show.generaDefinitiviRichiediPubblicazioni = true;
          self.disable.generaDefinitiviRichiediPubblicazioni = +this.actualGeneratedCoupon > 0 ? false : true;
        }

        if (self.certificationInfo.needsCertification && !self.certificationInfo.isCertificated) {
          self.disable.generaDefinitiviRichiediPubblicazioni = true;
        }

      }

      //chiedere a federico perchè di questa logica
      self.certificationInfo.loaded = true;
    });
  }

  enableCheckStatusContinuous(enabled: boolean) {
    if (enabled == true) {
      var self = this;
      this.interval = setInterval(() => {
        if (self.messageInstanceObject.status == "Q" || self.messageInstanceObject.status == "S" || self.messageInstanceObject.status == "R") {
          self.reloadStatusData();
        }
      }, 10000);
    }
    else {
      clearInterval(this.interval);
    }
  }
  reloadInfoStatus() {
    let currentStatus = this.statusList.find(x => x.code == this.messageInstanceObject.status);

    if (currentStatus) {
      this.statusDescription = currentStatus.description;

      if (
        currentStatus.code == this.statusMapping.infoBase.code ||
        currentStatus.code == this.statusMapping.planning.code ||
        currentStatus.code == this.statusMapping.emissionConditions.code ||
        currentStatus.code == this.statusMapping.fruitionConditions.code ||
        currentStatus.code == this.statusMapping.customerTarget.code ||
        currentStatus.code == this.statusMapping.productsTarget.code ||
        currentStatus.code == this.statusMapping.touchpoints.code ||
        currentStatus.code == this.statusMapping.validations.code
      ) {
        this.loadSchema(this.srvCampaign3.schema_modes.CREATE)
      }
      else if (
        currentStatus.code == this.statusMapping.completaPreview.code ||
        currentStatus.code == this.statusMapping.generataInPreview.code ||
        currentStatus.code == this.statusMapping.generazioneInErrore.code ||
        currentStatus.code == this.statusMapping.pubblicazioneRifiutata.code
      ) {
        this.loadSchema(this.srvCampaign3.schema_modes.EDIT_PREVIEW)
      }
      else if (currentStatus.code == this.statusMapping.pubblicata.code) {
        this.loadSchema(this.srvCampaign3.schema_modes.EDIT_DEFINITIVE)
      }
    }
  }

  //chiamato per valorizzare i wizard se presenti le regole
  setWizardValue() {
    let rulesEmission_WZ = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "WZ").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION);


    if (rulesEmission_WZ && rulesEmission_WZ.messageInstanceRuleDetail && rulesEmission_WZ.messageInstanceRuleDetail.length > 0) {
      for (let mird of rulesEmission_WZ.messageInstanceRuleDetail) {
        if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "TWIZ").id) {
          let tp_E_ON = this.touchPointEmission.find(x => x.ochannel_id == mird.objectValue);
          if (tp_E_ON && mird.objectValue && mird.objectId) {
            tp_E_ON.wizardModel = (tp_E_ON.wizardList && tp_E_ON.wizardList.length > 0) ? tp_E_ON.wizardList.find(x => x.id == mird.objectId) : null;
            if (mird.objectPriorty) {
              tp_E_ON["priority"] = mird.objectPriorty;
            }
          }
        }
      }
    };

    let rulesFruition_WZ = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "WZ").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION);


    if (rulesFruition_WZ && rulesFruition_WZ.messageInstanceRuleDetail && rulesFruition_WZ.messageInstanceRuleDetail.length > 0) {
      for (let mird of rulesFruition_WZ.messageInstanceRuleDetail) {
        if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "TWIZ").id) {
          let tp_F_ON = this.touchPointFruition.find(x => x.ochannel_id == mird.objectValue);
          if (tp_F_ON && mird.objectId) {

            tp_F_ON.wizardModel = (tp_F_ON.wizardList && tp_F_ON.wizardList.length > 0) ? tp_F_ON.wizardList.find(x => x.id == mird.objectId) : null;
            if (mird.objectPriorty) {
              tp_F_ON["priority"] = mird.objectPriorty;
            }
          }

        }
      }
    };
  }
  processData(localData: MessageInstanceObject) {
    //mappa body di messageinstance
    this.mapBodyData(localData);
    //conta i negozi
    this.countStores(localData);
    //mappiamo le regole
    this.mapInstanceData(localData);
    //rifiniamo i dati da presentare frontend

    this.summaryAccumulatorToControl = [];
    this.summaryAccumulatorToMove = [];
    this.summaryAccumulatorToControlFruition = [];
    this.summaryAccumulatorToMoveFruition = [];
    this.frontEndLogic(localData);

    this.setStatusDescription();
    //se presente una regola wz setta i wizard
    if (this.messageInstanceObject && this.messageInstanceObject.messageInstanceRule && this.messageInstanceObject.messageInstanceRule.length > 0) {
      if (this.messageInstanceObject.messageInstanceRule.some(rule => rule.ruleType === "WZ")) {
        this.setWizardValue();
      }
    }

    if (this.touchPointEmission && this.touchPointFruition) {
      this.checkWizardList();
    }




  }
  //navigazione durante l'edit
  onEdit(phaseNumber) {
    if (phaseNumber >= 0) {
      this.editClicked.emit(phaseNumber)
    }
  }
  performValidationValidationTarget(): boolean {
    let error = false;
    this.valid = (error == false) ? true : false;
    return this.valid;
  }

  resetDeploy(id) {

    let nextStatus = '0';
    this.srvCampaign3.resetDeploymentStateToComplete(id, nextStatus).subscribe(
      res => {
        console.log(res);
        this.resetState.emit();
      }
    )
  }

  fruitionRolling: boolean = false;
  mapBodyData(localData: any) {
    this.startEmissionDate = localData.startEmissionDate;
    this.endEmissionDate = localData.endEmissionDate;
    //se sono in rolling non devo farle vedere

    if (localData.couponValidityDateEndMode || localData.couponValidityDateEndMode) {
      this.fruitionRolling = true;
    }
    this.startFruitionDate = localData.startFruitionDate;
    this.endFruitionDate = localData.endFruitionDate;
    this.actionType = localData.actionType;
    this.name = localData.name;
    this.discountType = localData.discountType;
    //diviso 100
    this.description = localData.couponAmt / 100;
    this.actualGeneratedCoupon = localData.actualGeneratedCoupon;
    this.id = localData.id;



    //capire se la pubblicazione è stata rifiutata

    if (localData.status == "X") {
      this.publicationRejected = true;
      this.publicationRejectedMsgError = localData.couponDeploy.dpl_message;
    } else {
      this.publicationRejected = false;
      this.publicationRejectedMsgError = '';
    }

  }
  setAllButtonsVisible(isVisible: boolean) {
    this.show.aggiornaAzione = isVisible;
    this.show.generaCouponPreview = isVisible;
    this.show.generaDefinitiviRichiediPubblicazioni = isVisible;
    this.show.annullaPubblicazione = isVisible;
  }
  setAllButtonsDisable(isDisabled: boolean) {
    ;
    this.disable.aggiornaAzione = isDisabled;
    this.disable.generaCouponPreview = isDisabled;
    this.disable.generaDefinitiviRichiediPubblicazioni = isDisabled;
    this.disable.annullaPubblicazione = isDisabled;
  }
  isGeneraDefinitivoEnabled(): boolean {

    let res = true;
    if (this.certificationInfo.needsCertification && !this.certificationInfo.isCertificated)
      res = false;
    return res;
  }

  /*   checkIfAWizardIsSaved_old() {
  
      this.disable.generaCouponPreview = true;
      if (this.messageInstanceObject.messageInstanceRule) {
        this.messageInstanceObject.messageInstanceRule.forEach(
          el => {
            if (el.ruleType == "WZ") {
              this.disable.generaCouponPreview = false;
              this.disablingSavingWizardState = true;
              if (el.ruleScope == "fruition") {
                this.wizardEmissionComponent
              } else if (el.ruleScope = "emission") {
                this.wizardFruitionComponent
  
              }
            }
  
          }
        )
      }
  
    }
   */

  checkIfAWizardIsSaved() {

    this.disable.generaCouponPreview = true;
    this.disablingSavingWizardState = false;
    /*  this.isWizardEmissionDisabled = false;
     this.isWizardFruitionDisabled = false;  */

    if (this.messageInstanceObject.messageInstanceRule) {
      this.messageInstanceObject.messageInstanceRule.forEach(el => {

        if (el.ruleType == "WZ") {
          this.disable.generaCouponPreview = false;
          this.disablingSavingWizardState = true;

        }
      });
    }
  }


  checkIfGenerated() {
    const statusesToDisable = ['G', 'Q', 'P', 'S', 'X', 'U'];

    if (this.messageInstanceObject && statusesToDisable.indexOf(this.messageInstanceObject.status) !== -1) {
      this.disablingSavingWizardState = true;
    }
  }
  checkForButtons() {


    this.setAllButtonsVisible(false);
    this.setAllButtonsDisable(false);
    this.checkIfAWizardIsSaved();
    this.checkIfGenerated();



    var self = this;
    setTimeout(function () {

      //stato 0 --> completa, in preview
      //stato E --> quando si chiede la generazione in preview, se ci sono errori va in stato E
      if (self.messageInstanceObject.status == "0" || self.messageInstanceObject.status == "E") {
        self.show.generaCouponPreview = true;
        self.show.generaDefinitiviRichiediPubblicazioni = true;
        self.show.annullaPubblicazione = true;
        self.disable.generaDefinitiviRichiediPubblicazioni = true;
        self.disable.annullaPubblicazione = true;
        self.show.pubblicaNuovamente = false;
      }

      //stato G --> promo generata in preview
      else if (self.messageInstanceObject.status == "G") {
        self.show.generaDefinitiviRichiediPubblicazioni = true;
        self.show.annullaPubblicazione = true;
        self.disable.annullaPubblicazione = true;
        self.show.pubblicaNuovamente = false;
        self.disable.generaDefinitiviRichiediPubblicazioni = (+self.actualGeneratedCoupon) > 0 && self.isGeneraDefinitivoEnabled() == true ? false : true;
      }
      //stato Q --> richiesta pubblicazione
      //stato S --> pubblicazione invio
      //stato R --> in generazione coupon di preview
      else if (self.messageInstanceObject.status == "Q" || self.messageInstanceObject.status == "S" || self.messageInstanceObject.status == "R") {
        self.show.aggiornaAzione = true;
        self.show.pubblicaNuovamente = false;
        self.wizardMessagge = false;
      }
      //stato P --> promo pubblicata
      else if (self.messageInstanceObject.status == "P" && self.messageInstanceObject.flgDpl == '0') {
        self.show.annullaPubblicazione = true;
        //Attenzione provvisorio
        self.show.pubblicaNuovamente = true;
      }
      else if (self.messageInstanceObject.status == "P" && self.messageInstanceObject.flgDpl == '1') {
        self.show.annullaPubblicazione = true;
        //Attenzione provvisorio
        self.show.pubblicaNuovamente = true;
        self.disablingSavingWizardState = false;
        self.wizardMessagge = false;
        //proviamo a valutare la presenza dei wizard se ne ho almeno uno viene applicata la logica
        const hasWizard = self.messageInstanceObject.messageInstanceRule.some(
          element => element.ruleType === "WZ"
        );

        if (hasWizard) {
          console.log("Trovato almeno un wizard");
          self.wizardMessagge = false;
          self.disablingSavingWizardState = true;
          self.show.pubblicaNuovamente = true;
        } else {
          console.log("Nessun wizard salvato");
          self.wizardMessagge = true;
          self.disablingSavingWizardState = false;
          self.show.pubblicaNuovamente = false;
        }

      }

      //stato X --> pubblicazione rifiutata
      else if (self.messageInstanceObject.status == "X") {
        self.show.pubblicaNuovamente = true;

      }
      //stato U --> pubblicazione annullata
      else if (self.messageInstanceObject.status == "U") {
        self.show.pubblicaNuovamente = false;
      }

    }, 100);

  }
  wizardMessagge: boolean = false;



  countStores(data: any) {
    if (data.storeMessageOChannel) {
      let storeMessageList = data.storeMessageOChannel;
      let emission = [];
      let fruition = [];
      for (let record of storeMessageList) {
        if (record.storeType == 'E') {
          emission.push(record);
        }
        if (record.storeType == 'F') {
          fruition.push(record);
        }
      }
      this.numeroNegoziEmissione = emission.length;
      this.numeroNegoziFruizione = fruition.length;

    } else {
      this.numeroNegoziEmissione = 0;
      this.numeroNegoziFruizione = 0;
    }
  }

  mapInstanceData(data: any) {

    this.basket.include = 0;
    this.productDepartment.include = 0;
    this.productCategory.include = 0;
    this.productItem.include = 0;
    this.basket.exclude = 0;
    this.productDepartment.exclude = 0;
    this.productCategory.exclude = 0;
    this.productItem.exclude = 0;

    this.basketFruition.include = 0;
    this.productDepartmentFruition.include = 0;
    this.productCategoryFruition.include = 0;
    this.productItemFruition.include = 0;
    this.basketFruition.exclude = 0;
    this.productDepartmentFruition.exclude = 0;
    this.productCategoryFruition.exclude = 0;
    this.productItemFruition.exclude = 0;

    let messageInstanceRule = data.messageInstanceRule;

    //CV list
    let cvInstanceRuleDetail;
    let cvInstanceRuleDetailFruition;

    //LM List
    let lmInstanceRuleList;
    let lmInstanceRuleListFruition;

    //AC List
    let acInstanceRuleDetail;
    let acInstanceRuleDetailFruition;

    //BA List
    let baInstanceRuleDetail;

    //BC List
    let bcInstanceRuleDetail;

    //CT List
    let ctInstanceRuleDetail;
    let ctInstanceRuleDetailFruition;

    //OL List
    let olEmissionInstanceRuleDetail;
    let olFruitionInstanceRuleDetail;

    //PT List
    let ptInstanceRuleDetail;
    let ptInstanceRuleDetailFruition;

    //WZ List
    let wizardInstanceRuleDetail;
    let wizardInstanceRuleDetailFruition;

    if (messageInstanceRule) {
      for (let data of messageInstanceRule) {

        /*------------------------------CV--------------------------------*/

        //lista coupon con cv
        if (data.ruleType == "CV" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          cvInstanceRuleDetail = data.messageInstanceRuleDetail;
        }
        //lista coupon con cv fruizione
        if (data.ruleType == "CV" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          cvInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }

        /*------------------------------LM--------------------------------*/

        //lista coupon con cv
        if (data.ruleType == "LM" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          lmInstanceRuleList = data.messageInstanceRuleDetail;
        }
        //lista coupon con cv fruizione
        if (data.ruleType == "LM" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          lmInstanceRuleList = data.messageInstanceRuleDetail;
        }

        /*------------------------------AC--------------------------------*/

        //lista accumulatori
        if (data.ruleType == "AC" && data.ruleScope == "emission") {
          acInstanceRuleDetail = data.messageInstanceRuleDetail;
        }

        //lista accumulatori fruition
        if (data.ruleType == "AC" && data.ruleScope == "fruition") {
          acInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }


        /*------------------------------CT--------------------------------*/
        //lista customer target emission
        if (data.ruleType == "CT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          ctInstanceRuleDetail = data.messageInstanceRuleDetail;
        }

        //lista customer target fruition
        if (data.ruleType == "CT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          ctInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }

        /*------------------------------OL--------------------------------*/


        if (data.ruleType == "OL" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          olEmissionInstanceRuleDetail = data.messageInstanceRuleDetail;
        }

        //lista touchPointFruition
        if (data.ruleType == "OL" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          olFruitionInstanceRuleDetail = data.messageInstanceRuleDetail;
        }

        /*---------------------------BA & BC------------------------------*/

        //lista barcode attivatore
        if (data.ruleType == "BA" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          baInstanceRuleDetail = data.messageInstanceRuleDetail;
        }
        //lista barcode coupon
        if (data.ruleType == "BC" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          bcInstanceRuleDetail = data.messageInstanceRuleDetail;

        }

        /*------------------------------PT--------------------------------*/

        // lista per targetArticoliEmissione
        if (data.ruleType == "PT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          ptInstanceRuleDetail = data.messageInstanceRuleDetail;
        }
        // lista per targetArticoliFruizione
        if (data.ruleType == "PT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          ptInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }

        /*------------------------------WZ--------------------------------*/
        // lista per targetArticoliEmissione
        if (data.ruleType == "WZ" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          wizardInstanceRuleDetail = data.messageInstanceRuleDetail;
        }
        // lista per targetArticoliFruizione
        if (data.ruleType == "WZ" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          wizardInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }






      }

    }

    /***********************CV**************************/
    //dettagli del CV emissione

    if (cvInstanceRuleDetail) {

      for (let record of cvInstanceRuleDetail) {
        if (record && record.objectTypeCode == "PTRE") {
          this.emissionTreshold = record.objectValue / 100;
        }
        if (record && record.objectTypeCode == "PTRT") {
          this.emissionTrasholdType = record.objectValue;
        }
        /*
        if (record && record.objectTypeCode == "PMCN") {
          this.emissionMaxCouponNumber = record.objectValue;
        }
        */
        if (record && record.objectTypeCode == "PRTR") {
          this.ripetibleEmissionTreshold = record.objectValue / 100;
        }
        //
      }
    }
    //dettagli del CV fruizione
    if (cvInstanceRuleDetailFruition) {
      for (let record of cvInstanceRuleDetailFruition) {
        //fruition Trashold fruizione
        if (record && record.objectTypeCode == "PTRE") {
          this.fruitionTreshold = record.objectValue / 100;
        }
        if (record && record.objectTypeCode == "PTRT") {
          this.fruitionTrasholdType = record.objectValue;
        }
        if (record && record.objectTypeCode == "PMCN") {
          this.fruitionMaxCouponNumber = record.objectValue;
        }
        if (record && record.objectTypeCode == "PRTR") {
          this.ripetibleFruitionTreshold = record.objectValue;
        }

      }
    }
    /***********************LM**************************/


    if (lmInstanceRuleList) {
      for (let record of lmInstanceRuleList) {
        if (record && record.objectTypeCode == "TACM") {

          this.emissionTACM = record.description;
        }
        if (record && record.objectTypeCode == "PMCT") {
          //TODO attenzione campo complesso
          this.emissionPMCT = 'campo complesso TODO';
        }
      }
    }

    if (lmInstanceRuleListFruition) {
      for (let record of lmInstanceRuleListFruition) {
        if (record && record.objectTypeCode == "TACM") {

          this.fruitionTACM = record.description;
        }
        if (record && record.objectTypeCode == "PMCT") {
          //TODO attenzione campo complesso
          this.fruitionPMCT = 'campo complesso TODO';
        }
      }
    }

    /***********************AC**************************/

    if (acInstanceRuleDetail) {
      for (let record of acInstanceRuleDetail) {

        if (record && record.objectTypeCode == "JAAR") {

          this.emissionAccumulatorToMove = record.objectJson;
        }
        if (record && record.objectTypeCode == "JACR") {

          this.emissionAccumulatorToControl = record.objectJson;
        }

      }
    }


    if (acInstanceRuleDetailFruition) {
      for (let record of acInstanceRuleDetailFruition) {

        if (record && record.objectTypeCode == "JAAR") {

          this.fruitionAccumulatorToMove = record.objectJson;
        }
        if (record && record.objectTypeCode == "JACR") {

          this.fruitionAccumulatorToControl = record.objectJson;
        }

      }
      console.log(this.fruitionAccumulatorToMove)
      console.log(this.fruitionAccumulatorToControl)

    }


    /***********************BA**************************/

    //dettagli di barcodeAttivazione
    if (baInstanceRuleDetail) {
      for (let record of baInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TBCD" || record.objectTypeCode == "PBCD") {
          if (record && record.objectTypeCode == "TBCD") {

            this.productItemBarcodeAttivazione = record.objectValue;
          }
          if (record && record.objectTypeCode == "PBCD") {

            this.eanBarcodeAttivazione = record.objectValue;
          }
        }
      }
    }
    /***********************BC**************************/
    //dettagli di productItemBarcodeCupon

    if (bcInstanceRuleDetail) {
      for (let record of bcInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TBCD") {

          this.productItemBarcodeCupon = record.objectValue;
        }
        if (record && record.objectTypeCode == "PBCD") {

          this.eanBarcodeCoupon = record.objectValue;
        }
      }
    }

    /***********************CT**************************/
    //dettagli di distributionEmissionList
    if (ctInstanceRuleDetail) {
      for (let record of ctInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TDIS") {
          let dist = this.distributionListEmission.find(x => x.distributionListId == record.objectId);
          this.distributionEmissionList = dist ? dist.distributionListName : "";
        }
      }
    }
    //dettagli di distributionEmissionListFruition
    if (ctInstanceRuleDetailFruition) {
      for (let record of ctInstanceRuleDetailFruition) {
        if (record && record.objectTypeCode == "TDIS") {
          let dist = this.distributionListFruition.find(x => x.distributionListId == record.objectId);
          this.distributionFruitionList = dist ? dist.distributionListName : "";
        }
      }
    }


    /***********************OL**************************/
    //dettagli di touchpointEmission
    if (olEmissionInstanceRuleDetail) {
      this.touchPointEmission = [];
      for (let record of olEmissionInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TOCH") {
          let tp = this.touchpointListEmission.find(x => x.ochannel_id == record.objectId);
          if (tp) {
            this.touchPointEmission.push(tp);
          }
        }

      }
    }
    //dettagli di touchPointFruition
    if (olFruitionInstanceRuleDetail) {
      this.touchPointFruition = [];
      for (let record of olFruitionInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TOCH") {
          let tp = this.touchpointListFruition.find(x => x.ochannel_id == record.objectId);
          if (tp) {
            this.touchPointFruition.push(tp);
          }
        }

      }
    }

    /*   console.log(this.touchPointFruition)
      console.log(this.touchPointEmission) */
    /***********************WZ**************************/

    /*    if (wizardInstanceRuleDetail) {
         for (let record of wizardInstanceRuleDetail) {
           if (record && record.objectTypeCode == "TWIZ") {

             this.wizardEmission = record.objectTypeId;
           }
         }
       }
       if (wizardInstanceRuleDetailFruition) {
         for (let record of wizardInstanceRuleDetailFruition) {
           if (record && record.objectTypeCode == "TWIZ") {

             this.wizardFruition = record.objectTypeId;
           }
         }
       } */

    /***********************PT**************************/

    //Chiedere come trattare INCLUDE e EXCLUDE

    if (ptInstanceRuleDetail) {

      for (let record of ptInstanceRuleDetail) {

        if (record && record.objectTypeCode == "TBSK") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.basket.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.basket.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TDEP") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productDepartment.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productDepartment.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TCAT") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productCategory.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productCategory.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TPRD") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productItem.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productItem.exclude++;
          }
        }
      }
    }

    if (ptInstanceRuleDetailFruition) {

      for (let record of ptInstanceRuleDetailFruition) {

        if (record && record.objectTypeCode == "TBSK") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.basketFruition.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.basketFruition.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TDEP") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productDepartmentFruition.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productDepartmentFruition.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TCAT") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productCategoryFruition.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productCategoryFruition.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TPRD") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productItemFruition.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productItemFruition.exclude++;
          }
        }

      }
    }
  }

  frontEndLogic(localData: any) {

    if (localData.flgRolling == "1") {
      this.variableDates = true;
    }

    this.generationMethod = this.couponingMethodMap[localData.flgCouponingMethod] || '';
    this.targetLoyaltyClass = this.customerTarget[localData.targetLoyaltyClass] || '';

    //Barcode Attivazione
    if (this.productItemBarcodeAttivazione) {
      this.barcodeAttivazione = this.productItemBarcodeAttivazione;
    } else if (this.eanBarcodeAttivazione) {
      this.barcodeAttivazione = this.eanBarcodeAttivazione;
    }
    if (!this.barcodeAttivazione) {
      this.barcodeAttivazione = 'No';
    }
    //Barcode Coupon
    if (this.productItemBarcodeCupon) {
      this.barcodeCoupon = this.productItemBarcodeCupon;
    } else if (this.eanBarcodeCoupon) {
      this.barcodeCoupon = this.eanBarcodeCoupon;
    }
    if (!this.barcodeCoupon) {
      this.barcodeCoupon = 'No';
    }

    //Accumulatori in emissione
    if (this.emissionAccumulator) {
      this.accumulatoriEmissione = this.statusDescription = (this.language == "it" ? "Sì" : "Yes");
      'Si' //+ this.emissionAccumulator;
    } else {
      this.accumulatoriEmissione = 'No';
    }

    //Accumulatori in fruizione
    if (this.fruitionAccumulator) {
      this.accumulatoriFruizione = (this.language == "it" ? "Sì" : "Yes"); // + this.fruitionAccumulator;
    } else {
      this.accumulatoriFruizione = 'No';
    }

    //listaDistribuzioneEmissione
    if (this.distributionEmissionList) {
      this.listaDistribuzioneEmissione = (this.language == "it" ? "Sì" : "Yes") + ' (' + this.distributionEmissionList + ')';
    }
    else {
      this.listaDistribuzioneEmissione = (this.language == "it" ? "nessuna" : "none");;
    }

    //listaDistribuzioneFruizione
    if (this.distributionFruitionList) {
      this.listaDistribuzioneFruizione = (this.language == "it" ? "Sì" : "Yes"); + ' (' + this.distributionFruitionList + ')';
    }
    else {
      this.listaDistribuzioneFruizione = (this.language == "it" ? "nessuna" : "none");;
    }

    if ((this.basket.include + this.basket.exclude + this.productDepartment.include + this.productDepartment.exclude + this.productCategory.include + this.productCategory.exclude + this.productItem.include + this.productItem.exclude) > 0) {

      this.targetArticoliEmissione = "(";

      if ((this.basket.include + this.basket.exclude) > 0) {
        this.targetArticoliEmissione += (this.language == "it" ? "paniere " : "basket ");
        this.targetArticoliEmissione += this.basket.include > 0 ? this.basket.include + " (I), " : "";
        this.targetArticoliEmissione += this.basket.exclude > 0 ? this.basket.exclude + " (E), " : "";
      }
      if ((this.productDepartment.include + this.productDepartment.exclude) > 0) {
        this.targetArticoliEmissione += (this.language == "it" ? "reparto " : "department ");
        this.targetArticoliEmissione += this.productDepartment.include > 0 ? this.productDepartment.include + " (I), " : "";
        this.targetArticoliEmissione += this.productDepartment.exclude > 0 ? this.productDepartment.exclude + " (E), " : "";
      }
      if ((this.productCategory.include + this.productCategory.exclude) > 0) {
        this.targetArticoliEmissione += (this.language == "it" ? "categorie " : "categories ");
        this.targetArticoliEmissione += this.productCategory.include > 0 ? this.productCategory.include + " (I), " : "";
        this.targetArticoliEmissione += this.productCategory.exclude > 0 ? this.productCategory.exclude + " (E), " : "";
      }
      if ((this.productItem.include + this.productItem.exclude) > 0) {
        this.targetArticoliEmissione += (this.language == "it" ? "articoli " : "products ");
        this.targetArticoliEmissione += this.productItem.include > 0 ? this.productItem.include + " (I), " : "";
        this.targetArticoliEmissione += this.productItem.exclude > 0 ? this.productItem.exclude + " (E), " : "";
      }
      this.targetArticoliEmissione = this.targetArticoliEmissione.slice(0, -2);
      this.targetArticoliEmissione += ")";
    } else {
      this.targetArticoliEmissione = 'no';
    }

    if ((this.basketFruition.include + this.basketFruition.exclude + this.productDepartmentFruition.include + this.productDepartmentFruition.exclude + this.productCategoryFruition.include + this.productCategoryFruition.exclude + this.productItemFruition.include + this.productItemFruition.exclude) > 0) {
      this.targetArticoliFruizione = "(";
      if ((this.basketFruition.include + this.basketFruition.exclude) > 0) {
        this.targetArticoliFruizione += (this.language == "it" ? "paniere " : "basket ");
        this.targetArticoliFruizione += this.basketFruition.include > 0 ? this.basketFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.basketFruition.exclude > 0 ? this.basketFruition.exclude + " (E), " : "";
      }
      if ((this.productDepartmentFruition.include + this.productDepartmentFruition.exclude) > 0) {
        this.targetArticoliFruizione += (this.language == "it" ? "reparto " : "department ");
        this.targetArticoliFruizione += this.productDepartmentFruition.include > 0 ? this.productDepartmentFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.productDepartmentFruition.exclude > 0 ? this.productDepartmentFruition.exclude + " (E), " : "";
      }
      if ((this.productCategoryFruition.include + this.productCategoryFruition.exclude) > 0) {
        this.targetArticoliFruizione += (this.language == "it" ? "categorie " : "categories ");
        this.targetArticoliFruizione += this.productCategoryFruition.include > 0 ? this.productCategoryFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.productCategoryFruition.exclude > 0 ? this.productCategoryFruition.exclude + " (E), " : "";
      }
      if ((this.productItemFruition.include + this.productItemFruition.exclude) > 0) {
        this.targetArticoliFruizione += (this.language == "it" ? "articoli " : "products ");
        this.targetArticoliFruizione += this.productItemFruition.include > 0 ? this.productItemFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.productItemFruition.exclude > 0 ? this.productItemFruition.exclude + " (E), " : "";
      }
      this.targetArticoliFruizione = this.targetArticoliFruizione.slice(0, -2);
      this.targetArticoliFruizione += ")";
    } else {
      this.targetArticoliFruizione = 'no';
    }

    //Touchpoint Emissione
    if (this.touchPointEmission && this.touchPointEmission.length > 0) {
      this.touchPointEmissione = "";


      for (let tp of this.touchPointEmission) {
        this.touchPointEmissione += tp.description + ", ";
      }
      this.touchPointEmissione = this.touchPointEmissione.slice(0, -2);
    } else {
      this.touchPointEmissione = 'nessuno';
    }


    //TODO portare logica anche in fruition
    /* if (this.touchPointEmission && this.touchPointEmission.length > 0) {
      this.certifierTouchPointEmission = [];
      for (let tp of this.touchPointEmission) {

          this.certifierTouchPointEmission.push(tp);

      }
    } */



    //Touchpoint Fruizione
    if (this.touchPointFruition && this.touchPointFruition.length > 0) {
      this.touchPointFruizione = "";
      for (let tp of this.touchPointFruition) {
        this.touchPointFruizione += tp.description + ", ";
      }
      this.touchPointFruizione = this.touchPointFruizione.slice(0, -2);
    } else {
      this.touchPointFruizione = 'nessuno';
    }
    //CertifierTouchPointFruition
    /*   if (this.touchPointFruition && this.touchPointFruition.length > 0) {
        for (let tp of this.touchPointFruition) {
          if (tp.certifier == "Yes" && !this.certifierTouchPointFruition.some(existingTp => existingTp.description === tp.description)) {

            console.log(tp);
            this.certifierTouchPointFruition.push(tp);
          }
        }
      } */



    //sogliaDiEmissione
    if (this.emissionTrasholdType && this.emissionTrasholdType == "EV") {
      this.sogliaDiEmissione.type = (this.language == "it" ? "Valore " : "Value ");
      this.sogliaDiEmissione.value = this.emissionTreshold;
    }
    //sogliaDiEmissione
    if (this.emissionTrasholdType && this.emissionTrasholdType == "QT") {
      this.sogliaDiEmissione.type = (this.language == "it" ? "Quantità " : "Quantity ");
      this.sogliaDiEmissione.value = this.emissionTreshold;
    }
    if (!this.emissionTrasholdType) {
      this.sogliaDiEmissione.type = 'No';
    }

    //Soglia di fruizione, TODO attenzione che nella validazione mi ritorna un caso con fruitionTrasholdType=V
    if (this.fruitionTrasholdType && this.fruitionTrasholdType == "EV") {

      this.sogliaDiFruizione.type = (this.language == "it" ? "Valore " : "Value ");
      this.sogliaDiFruizione.value = this.fruitionTreshold;
    }
    if (this.fruitionTrasholdType && this.fruitionTrasholdType == "QT") {
      this.sogliaDiFruizione.type = (this.language == "it" ? "Quantità " : "Quantity ");
      this.sogliaDiFruizione.value = this.fruitionTreshold;
    }
    if (!this.fruitionTrasholdType) {
      this.sogliaDiFruizione.type = 'No';
    }
    // console.log(this.emissionMaxCouponNumber)

    //Emissione Ripetibile
    /*
    if (this.ripetibleEmissionTreshold) {

      this.emissioneRipetibile.type = "si";
      const intValue = parseInt(this.emissionMaxCouponNumber);
      if (!isNaN(intValue)) {
        this.emissioneRipetibile.value = intValue / 100;
        this.emissioneRipetibile.max = intValue;
      } else {
        console.error("record.objectValue non è un numero valido");
      }
    } else {
      this.emissioneRipetibile.type = "No";
    }
*/
    //Fruizione Ripetibile
    if (this.ripetibleFruitionTreshold) {
      this.fruizioneRipetibile.type = "si";
      const intValue = parseInt(this.fruitionMaxCouponNumber);
      if (!isNaN(intValue)) {
        this.fruizioneRipetibile.value = intValue / 100;
        this.fruizioneRipetibile.max = intValue;
      } else {
        console.error("record.objectValue non è un numero valido");
      }
    } else {
      this.fruizioneRipetibile.type = "No";
    }


    //Accumulatori EMISSIONE
    // --- Controllo (JACR) ---
    if (this.emissionAccumulatorToControl && Array.isArray(this.emissionAccumulatorToControl.check)) {
      const checkList = this.emissionAccumulatorToControl.check;

      for (let check of checkList) {
        const matchingAccumulator = this.accumulatorListEmission.find(acc => acc.id == check.acm_id);

        if (matchingAccumulator) {
          console.log('Trovato (controllo):', matchingAccumulator);
          this.summaryAccumulatorToControl.push(matchingAccumulator);
        } else {
          console.warn('Accumulatore non trovato per ID (controllo):', check.acm_id);
        }
      }
    }

    // --- Movimentazione (JAAR) ---
    if (this.emissionAccumulatorToMove && Array.isArray(this.emissionAccumulatorToMove.move)) {
      const moveList = this.emissionAccumulatorToMove.move;

      for (let move of moveList) {
        const matchingAccumulator = this.accumulatorListEmission.find(acc => acc.id == move.acm_id);

        if (matchingAccumulator) {
          console.log('Trovato (movimento):', matchingAccumulator);
          this.summaryAccumulatorToMove.push(matchingAccumulator);
        } else {
          console.warn('Accumulatore non trovato per ID (movimento):', move.acm_id);
        }
      }
    }


    //FRUIZIONE

    // --- Controllo (JACR) ---
    if (this.fruitionAccumulatorToControl && Array.isArray(this.fruitionAccumulatorToControl.check)) {
      const checkList = this.fruitionAccumulatorToControl.check;

      for (let check of checkList) {
        const matchingAccumulator = this.accumulatorListFruition.find(acc => acc.id == check.acm_id);
        if (matchingAccumulator) {
          console.log('Trovato (controllo):', matchingAccumulator);
          this.summaryAccumulatorToControlFruition.push(matchingAccumulator);
        } else {
          console.warn('Accumulatore non trovato per ID (controllo):', check.acm_id);
        }
      }
    }
    // --- Movimentazione (JAAR) ---
    if (this.fruitionAccumulatorToMove && Array.isArray(this.fruitionAccumulatorToMove.move)) {
      const moveList = this.fruitionAccumulatorToMove.move;
      for (let move of moveList) {
        const matchingAccumulator = this.accumulatorListFruition.find(acc => acc.id == move.acm_id);
        if (matchingAccumulator) {
          console.log('Trovato (movimento):', matchingAccumulator);
          this.summaryAccumulatorToMoveFruition.push(matchingAccumulator);
        } else {
          console.warn('Accumulatore non trovato per ID (movimento):', move.acm_id);
        }
      }
    }


  }


  reloadData() {
    this.show.form = false;

    this.sogliaDiEmissione = { type: '', value: 0 };
    this.sogliaDiFruizione = { type: '', value: 0 };
    this.emissioneRipetibile = { type: '', value: 0, max: 0 };
    this.fruizioneRipetibile = { type: '', value: 0, max: 0 };
    var self = this;
    setTimeout(function () {
      if (self.messageInstanceObject) {
        self.processData(self.messageInstanceObject);
        self.checkForButtons();



        /*    if(self.messageInstanceObject.id>0 && !self.certificationInfo.loaded && self.touchPointEmission.length> 0 && self.touchPointFruition.length>0){ */
        if (self.messageInstanceObject.id > 0 && !self.certificationInfo.loaded) {
          self.checkCertificationInfo();
        }

        if (self.messageInstanceObject.status == 'P' && !self.deployTypesLoaded && self.deployTypeCoupon == self.srvKPromo.deployTypeCodes.KPROMO) {
          //KS-7382 - se è KPROMO fare chiamata e costruire il link per aprire kpromo. 
          self.srvKPromo.getDeployType(self.messageInstanceObject.id).subscribe(res => {
            if (res && res.length > 0) {
              self.deployTypeList = res;
              self.deployTypesLoaded = true;
            }
          });
        }

      }
      self.show.form = true;
    }, 100);

  }
  onClickDeployType(dt: DeployType) {

    const token = this.srvAuth.user.token;
    const language = this.srvAuth.sessionHelper.selectedLanguage;

    if (token && language && dt.id_promo_head_fk && dt.id_promo_off_fk) {

      // Costruisci l'URL interno
      const promoUrl = `/promotion/promoDetail.aspx?PROMOOFF=${dt.id_promo_off_fk}&PROMOHEAD=${dt.id_promo_head_fk}`;

      // Codifica l'URL interno per evitare conflitti
      const encodedPromoUrl = encodeURIComponent(promoUrl);

      // Costruisci l'URL completo
      //const completeUrl = `${baseUrl}/kpromo2koncentro/verificajwt.aspx` +
      const completeUrl = `/kpromo2koncentro/verificajwt.aspx` +
        `?bearer=${token}` +
        `&lang=${language}` +
        `&url=${encodedPromoUrl}`;

      if (completeUrl != "") {
        window.open(completeUrl, "_blank");
      }
    }
    else {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.deploy_error')
      });
    }

  }

  //TODO verificare uso di this e self
  loadSchema(mode: string) {
    //carica il form schema a seconda della scelta della combo tipo coupon
    var self = this;

    self.srvCampaign3.getJsonFormSchema(this.actionTypeCode, mode, this.messageInstanceObject.messageId.toString()).subscribe(resSchema => {

      if (resSchema && resSchema.length == 1) {

        let newSchema = self.srvCampaign3.getPreparedFormSchemas(resSchema[0]);
        setTimeout(function () {
          newSchema.mode = mode;
          self.formSchemaChanged.emit(newSchema);
        }, 100)

      }
      else {
        self.formSchemaChanged.emit(null);
        self.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.no_template_schema')
        });
      }

    });
  }
  onClickGeneraCouponPreview() {

    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});
    var self = this;

    this.srvCampaign3.preview(this.campaignInfo.id, this.messageInstanceObject.id, false).subscribe(res => {
      //TODO chiedere quale parametro mi permette di capire se è già andata in preview in modo  da nascondere il salvataggio
      if (res) {
        self.srvNotify.add({
          severity: 'success',
          summary: this.translate.instant('common.success'),
          detail: this.translate.instant('campaign.coupon_preview_generation_successful')
        });
      } else {
        self.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.error_coupon_preview_generation')
        });
      }

      self.reloadStatusData();
    });

  }
  onClickGeneraCouponDefinitivi() {
    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});

    if (this.messageInstanceObject.status == "G") {

      let publishable = this.certificationInfo.needsCertification ? (this.certificationInfo.isCertificated == true ? true : false) : false;

      var self = this;
      console.log(publishable);

      this.srvCampaign3.publish(this.campaignInfo.id, this.messageInstanceObject.id, publishable).subscribe(res => {
        if (res) {
          self.srvNotify.add({
            severity: 'success',
            summary: this.translate.instant('common.success'),
            detail: this.translate.instant('campaign.final_coupon_generation_successful')
          });
        } else {
          self.srvNotify.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('campaign.error_final_coupon_generation')
          });
        }

        self.reloadStatusData();
      });

    }
    else {

      self.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.no_conditions_to_publish_promo')
      });


    }
  }
  reloadStatusData() {
    var self = this;
    this.srvCampaign3.getMessageInstanceComplete(this.messageInstanceObject.id).subscribe(res => {
      if (res && res.messageInstance.length == 1) {
        let mi = res.messageInstance[0];
        self.messageInstanceObject = mi;
        self.messageInstanceObjectChange.emit(mi);

        self.checkForButtons();
        self.reloadInfoStatus();
      }
    })
  }
  onClickAggiornaAzione() {
    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});
    if (this.messageInstanceObject.status == "Q" || this.messageInstanceObject.status == "S" || this.messageInstanceObject.status == "R") {
      this.reloadStatusData();
    }
  }


  onClickAnnullaPubblicazione() {
    this.displayDeleteDialog = true;
  }

  closePopupDelete() {
    this.displayDeleteDialog = false;
  }


  onAnnullaPubblicazione() {
    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});
    var self = this;
    this.srvCampaign3.undoPublish(this.campaignInfo.id, this.messageInstanceObject.id, false).subscribe(res => {
      if (res) {

        self.srvNotify.add({
          severity: 'success',
          summary: this.translate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.translate.instant('campaign.publication_cancellation_successful')
        });
      } else {
        self.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.error_during_publication_cancellation')
        });
      }
      this.displayDeleteDialog = false;
      self.unpublishCompleted.emit();

      //self.reloadData();

    })
  }


  @Output() unpublishCompleted = new EventEmitter<void>();
  onClickGeneratedCoupon() {

    if (+this.actualGeneratedCoupon > 0) {
      this.show.modalCoupon = true;
    }
  }
  ngOnDestroy() {
    // Pulizia dell'intervallo quando il componente viene distrutto
    this.enableCheckStatusContinuous(false);
  }



  //TODO non ancora funzionante
  onChangeWizard(type: string, offline_online: string, touchpoint: Touchpoint, wizard: any) {
    ;
    this.disable.generaCouponPreview = true;
    this.setCurrentInfo(type, offline_online, touchpoint);
  }
  //TODO non ancora funzionante
  setCurrentInfo(type: string, offline_online: string, touchpoint: Touchpoint) {
    this.currentInfo.type = type;
    this.currentInfo.offline_online = offline_online;
    this.currentInfo.touchpointSelected = touchpoint;
  }
  //TODO non ancora funzionante
  onClickSearchWizard(type: string, touchpoint: Touchpoint, index: number) {
    let offline_online = touchpoint.flg_offline == "1" ? 'OFF' : 'ON';
    this.setCurrentInfo(type, offline_online, touchpoint);
    this.wizardList = touchpoint.wizardList;
    this.show.modalWizard = true;
  }


  //TODO in test: 1686
  onWizardSelected(wizard: any) {
    let selectedTouch = this.currentInfo.touchpointSelected;
    let touchType = this.currentInfo.type;

    if (touchType == 'F') {

      let index = this.touchPointFruition.findIndex(el =>
        el.ochannel_id === selectedTouch.ochannel_id &&
        el.code === selectedTouch.code &&
        el.layout_id === selectedTouch.layout_id
      );

      if (index !== -1) {
        // Sostituisci l'elemento nell'array
        this.touchPointFruition[index].wizardModel = wizard;
        console.log("Touchpoint aggiornato:", this.touchPointFruition[index]);
      } else {
        console.log("Nessun touchpoint selezionato corrisponde");
      }


    }


    if (touchType == 'E') {
      let index = this.touchPointEmission.findIndex(el =>
        el.ochannel_id === selectedTouch.ochannel_id &&
        el.code === selectedTouch.code &&
        el.layout_id === selectedTouch.layout_id
      );

      if (index !== -1) {
        // Sostituisci l'elemento nell'array
        this.touchPointEmission[index].wizardModel = wizard;
        console.log("Touchpoint aggiornato:", this.touchPointEmission[index]);
      } else {
        console.log("Nessun touchpoint selezionato corrisponde");
      }


    }



    //dal touchpoint determino se è fruition o emission

    //this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].wizardModel = Object.assign({},wizard);
    this.show.modalWizard = false;
  }
  onClickAnnulla_ModalWizard() {
    this.resetCurrentInfo();
    this.show.modalWizard = false;
  }
  resetCurrentInfo() {
    this.currentInfo.type = null;
    this.currentInfo.offline_online = null;
    this.currentInfo.touchpointSelected = null;
  }
  onSaveWizard() {
    let allValid = true;
    if (this.wizardEmissionComponent && this.wizardEmissionComponent.length > 0) {
      this.wizardEmissionComponent.forEach((component) => {
        if (component.fieldModel == null) {
          allValid = false;
        }
      });
    }

    if (this.wizardFruitionComponent && this.wizardFruitionComponent.length > 0) {
      this.wizardFruitionComponent.forEach((component) => {
        if (component.fieldModel == null) {
          allValid = false;
        }
      });
    }

    if (allValid) {
      this.saveWizard.emit();
    } else {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.select_all_wizard_warning')
      });
    }
  }






  checkWizardList() {
    for (let tp of this.touchPointEmission) {

      if (tp.wizardList && tp.certifier == this.srvCampaign3.touchpointCertifier.YES && tp.wizardList.length == 1) {
        tp.wizardModel = tp.wizardList[0];
        if (tp.wizardList.length == 1) {
          this.isWizardEmissionDisabled = true;
        }
      }
    }
    for (let tp of this.touchPointFruition) {

      if (tp.wizardList && tp.certifier == this.srvCampaign3.touchpointCertifier.YES && tp.wizardList.length == 1) {
        tp.wizardModel = tp.wizardList[0];
        if (tp.wizardList.length == 1) {
          this.isWizardFruitionDisabled = true;
        }
      }
    }

  }

  onClickPubblicaNuovamente() {
    // Condizione di stato valida
    if (this.messageInstanceObject.status === 'P' || this.messageInstanceObject.status === 'X') {

      const publishable = this.certificationInfo.needsCertification
        ? this.certificationInfo.isCertificated === true
        : false;

      console.log('Publishable:', publishable);

      // Cambiare con la nuova chiamata se necessario
      this.srvCampaign3.publish(this.campaignInfo.id, this.messageInstanceObject.id, publishable)
        .subscribe({
          next: (res: boolean) => {
            if (res) {
              this.srvNotify.add({
                severity: 'success',
                summary: this.translate.instant('common.success'),
                detail: this.translate.instant('campaign.final_coupon_generation_successful')
              });
            } else {
              this.srvNotify.add({
                severity: 'error',
                summary: this.translate.instant('common.error'),
                detail: this.translate.instant('campaign.error_final_coupon_generation')
              });
            }
            this.reloadStatusData();
          },
          error: () => {
            this.srvNotify.add({
              severity: 'error',
              summary: this.translate.instant('common.error'),
              detail: this.translate.instant('campaign.error_final_coupon_generation')
            });
          }
        });
    } else {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.no_conditions_to_publish_promo')
      });
    }
  }






}




// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-validations/campaign-3-validations.component.ts